import { render } from "./ModelViewer3d.vue?vue&type=template&id=0f5a4db6&scoped=true"
import script from "./ModelViewer3d.vue?vue&type=script&lang=js"
export * from "./ModelViewer3d.vue?vue&type=script&lang=js"

import "./ModelViewer3d.vue?vue&type=style&index=0&id=0f5a4db6&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5a4db6"]])

export default __exports__